
import Page from '@root/common/base/Page';
import CustomerNavigation from '@root/modules/customer/components/CustomerNavigation.vue';
import LoyaltyRules from '@root/modules/customer/components/loyalty/Rules.vue';
import FAQ from '@root/modules/customer/components/loyalty/FAQ.vue';
import Offers from '@root/modules/customer/components/loyalty/Offers.vue';
import getPageAdsSettings from '@root/modules/customer/utils/getPageAdsSettings';

interface cXWindow extends Window {
  [index: string]: any;
}
declare let window: cXWindow;

export default Page.extend({
  components: {
    CustomerNavigation,
    LoyaltyRules,
    Offers,
    FAQ,
  },
  computed: {
    hasChannelSubscription() {
      return this.$store.state.piano.access.channelAccess;
    },
    customerToken(): string {
      return this.$store.state.piano.token;
    },
  },
  methods: {
    logLoyaltyButtonClick(event: string) {
      if (window.cX && typeof window.cX.sendEvent === 'function') {
        window.cX.sendEvent(
          event,
          {
            user_id: this.$store.state.piano.profile.sub,
          },
          { origin: 'lth-delfi', persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8' }
        );
      }
    },
    navigateAndLog(event: string) {
      this.logLoyaltyButtonClick(event);
      this.$router.push('/puslapis/prenumerata');
    },
  },
  created() {
    this.setPageAdsSettings(getPageAdsSettings({ $channelConfig: this.$channelConfig }));
  },
});
